import numbro from 'numbro';

class NumbroUtils {
  public static setCurrencySymbol(symbol: string) {
    Object.values(numbro.languages()).forEach((language: numbro.NumbroLanguage) => {
      language.currency.symbol = symbol;
    });
  }
}

export default NumbroUtils;
